import { Component, OnInit } from '@angular/core';
import { ZoneCoordModel } from '../shared/models/zone-model';
@Component({
  selector: 'app-tovpil-catalogs-coord-team',
  templateUrl: './tovpil-catalogs-coord-team.component.html',
  styleUrls: ['./tovpil-catalogs-coord-team.component.scss']
})
export class TovpilCatalogsCoordTeamComponent implements OnInit {

  listZonesCoord: ZoneCoordModel[];


  constructor() { }

  ngOnInit(): void {
    console.debug("Fire OnInit Coord Team");
  }



}
